import {styled} from "@reside/ui";

export const Wrapper = styled.div`
  max-height: 50vh;
  display: flex;
  flex-direction: column;
  width: 400px;
  z-index: 1;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 4px 10px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  overflow: hidden;
`;

export const Scrollable = styled.div`
  height: inherit;
  max-height: inherit;
  overflow-y: scroll;
`;

export const SpinnerWrapper = styled.div`
  background-color: ${({theme}) => theme.color.white};
  padding: 20px;
`;
